import { render, staticRenderFns } from "./PlayerView.vue?vue&type=template&id=3ad01aca&"
import script from "./PlayerView.vue?vue&type=script&lang=js&"
export * from "./PlayerView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports